// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"_2q-m9y9To1WT","content":"_1gAM5q5pTNBG"};